import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import ContentSkeleton from "../../Skeleton/ContentSkeleton";
import { getCalendarLists, getInitUrlCalendar, grantPermissionsCalendar, insertCalendar, postTokensOauth } from "../../../../api/calendar";
import { alertError } from "../../../../utils/logger";
import {
  isGoogleCalendarTokenExpiredError,
  promptReconnectGoogleCalendar,
} from "../../../../utils/googleCalendarAuth";

/*
    Las fases de esta pagina son:
    1 -> refresh=true -> Pedimos la url de autenticación y la pegamos
    2 -> refresh=false&code... -> Se acaba de iniciar sesión en google y hay que setear los tokens. Una vez seteados salta directamente a la 3
    3 -> refresh=false -> Aquí ya accedemos al calendar. De momento se redirige a dashboard porque parece que no será necesario acceder al calendario desde aquí
*/
export default function CalendarPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const refr = searchParams.get("refresh")
    const code = searchParams.get("code")

    function state() {
        if (refr && refr === "true") return 1;
        if (refr && refr === "false" && code) return 2;
        return 3;
    }

    const [googleUrl, setGoogleUrl] = useState(null);

    // Se espera a tener la sesión cargada: si se salta a Google mientras la app comprueba
    // las credenciales, la redirección se interrumpe y la página se queda cargando.
    useEffect(() => {
        if (state() !== 1 || !user?._id) return;
        getInitUrlCalendar()
            .then((res) => {
                setGoogleUrl(res.data);
                window.location.assign(res.data);
            })
            .catch((error) => {
                alertError({ error, message: "No se ha podido cargar el calendario."})
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?._id]);

    async function getToken() {
        if (state() !== 2) return;
        console.log("TOKEN");
        postTokensOauth(code, user?._id)
            .then((res) => {
                history.push("/dashboard");
            })
            .catch((error => {
                console.log(error?.request)
                if (error?.response?.data?.code === "GOOGLE_WRONG_ACCOUNT") {
                    alertError({ error, message: "Cuenta de Google incorrecta" });
                    history.push("/dashboard");
                    return;
                }
                history.push("/calendar?refresh=true");
            }))
    }

    async function getLists() {
        if (state() !== 3) return;
        console.log("LO INTENTO")
        getCalendarLists(user?._id)
            .then((res) => {
                console.log(res?.data?.items);
            })
            .catch((error => {
                console.log(error?.request)
                if (isGoogleCalendarTokenExpiredError(error)) {
                    promptReconnectGoogleCalendar(history);
                    return;
                }
                alertError({ error, message: "No se han podido cargar la lista de calendarios."})
            }))
    }

    async function insertInCalendar() {
        if (state() !== 3) return;
        console.log("LO INTENTO")
        insertCalendar(user?._id)
            .then((res) => {
                console.log(res?.data)
            })
            .catch((error => {
                console.log(error?.request)
                if (isGoogleCalendarTokenExpiredError(error)) {
                    promptReconnectGoogleCalendar(history);
                    return;
                }
                alertError({ error, message: "No se han podido cargar la lista de calendarios."})
            }))
    }

    async function grantPermissions() {
        if (state() !== 3) return;
        console.log("LO INTENTO")
        grantPermissionsCalendar(user?._id, user?.fullName, user?.surname, user?.email)
            .then((res) => {
                console.log(res?.data)
            })
            .catch((error => {
                console.log(error?.request)
                if (isGoogleCalendarTokenExpiredError(error)) {
                    promptReconnectGoogleCalendar(history);
                    return;
                }
                alertError({ error, message: "No se han podido cargar la lista de calendarios."})
            }))
    }

    useEffect(() => {
        getToken();
        // Tras OAuth, el onboarding continúa en /dashboard; usuarios ya verificados irán a /clients desde DashboardPage
        if (state() === 3) history.push("/dashboard");
    }, [])

    // Si la redirección automática no llega a producirse, el usuario puede continuar a mano
    if (state() === 1 && googleUrl) return (
        <div style={{ padding: 24 }}>
            <p>Redirigiendo a Google para conectar tu calendario...</p>
            <a className="btn btn-primary text-white" href={googleUrl}>
                Continuar con Google
            </a>
        </div>
    );

    if (state() !== 3) return (<> <ContentSkeleton /> </>);
    return (<>
    
        <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => getLists()}
        >
            Coger listas
        </button>
    
        <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => insertInCalendar()}
        >
            Insertar calendario
        </button>
    
        <button
            type="button"
            className="btn btn-primary text-white"
            onClick={() => grantPermissions()}
        >
            Permisos!
        </button>
    </>)
}